import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IUserDto } from 'src/app/core/models';
import { BearerToken } from 'src/app/core/models/bearer.token';
import { AuthService, ToastService, TokenService } from 'src/app/core/services';
@Component({
  selector: 'ic-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  public formErrors: any = {};
  public profileForm: FormGroup;
  public client: BearerToken;

  constructor(
    private readonly fb: FormBuilder,
    private readonly authService: AuthService,
    private readonly toastService: ToastService,
    public readonly activeDialog: NgbActiveModal,
    private readonly tokenService: TokenService
  ) {
    this.client = this.tokenService.getToken();
  }

  ngOnInit() {
    this.profileForm = this.fb.group({
      name: [
        this.client.fullName,
        [Validators.required, Validators.maxLength(50)],
      ],
      email: [
        {
          value: this.client.email,
          disabled: true,
        },
        [Validators.required, Validators.maxLength(100), Validators.email],
      ],
      mobile: [
        this.client.mobile,
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
    });

    // This forces validation.
    Object.keys(this.profileForm.controls).forEach((key) => {
      this.profileForm.get(key).markAsTouched();
    });

    this.profileForm.valueChanges.subscribe((changes) => {
      Object.keys(changes).forEach((controlName) => {
        const control = this.profileForm.controls[controlName];
        this.formErrors[controlName] =
          (control.touched || control.dirty) && control.errors ? 'error' : null;
      });
    });
  }

  get fc() {
    return this.profileForm.controls;
  }

  updateProfile(): void {
    if (!this.profileForm.dirty) {
      this.toastService.showSuccess('Profile updated successfully');
      this.closeDialog();
      return;
    }
    const model: IUserDto = {
      ...this.profileForm.value,
    };
    this.authService.updateProfile(model).subscribe(
      (data) => {
        this.toastService.showSuccess('Profile updated successfully');
        this.authService.updateProfileToken(model.name, model.mobile);
        this.closeDialog();
      },
      (err) => {
        this.toastService.showError(err.exceptionMessage || err.message);
      }
    );
  }

  closeDialog() {
    this.activeDialog.close();
  }
}
